export interface ApiErrorSchema {
    errorCode: number;
    errorMessage: string;
    retryable: boolean;
}

export const IsApiErrorSchema = (message: unknown): message is ApiErrorSchema => {
    return (message as ApiErrorSchema) != undefined;
}